import axios from "axios";

export function authHeader() {
  // return authorization header with jwt token

  let token = sessionStorage.getItem("token") || "{}";

  if (token) {
    axios.defaults.headers.common["Authorization"] = "JWT " + token;
    return { Authorization: "JWT " + token };
  } else {
    return {};
  }
}
